// TODO: simplify to use just in activity thumbnail

import React from "react";
import { observer, inject } from "mobx-react";
import { injectIntl } from "react-intl";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

@injectIntl
@inject("rootStore")
@observer
export default class Attachment extends React.Component {
  constructor(props) {
    super(props);

    this.hasThumbnail =
      !props.attachment.externalLink &&
      props.attachment.attachmentName.match(/.(jpg|jpeg|png|gif)$/i);
    this.canEdit = props.rootStore.authorizationStore.canEditAttachment(
      props.attachment
    );
  }

  render() {
    const { intl, attachment, note } = this.props;

    return (
      <div className="note-attachment-container">
        {this.renderAttachment(attachment)}
      </div>
    );
  }

  renderAttachment = attachment => {
    const { intl, note } = this.props;

    // const attachmentExtension = attachment.attachmentName.split('.').pop();
    // let renderRetValue;
    const previewIconClass = attachment.hidePreview
      ? "fa fa-eye-slash"
      : "fa fa-eye";
    const toggleHideTooltip = (
      <Tooltip id={`hide-show-preview-${attachment.id}`}>
        {intl.formatMessage({ id: "hide_show_from_board" })}
      </Tooltip>
    );

    return (
      <a
        className="react-attachment-thumbnail-container"
        target="_blank"
        href={attachment.attachmentUrl}
      >
        <div className="thumbnail">
          <div className="attachment-thumbnail-img-holder">
            {this.hasThumbnail ? (
              <img src={attachment.attachmentUrl} alt="..." />
            ) : (
              <React.Fragment>
                <br />
                <i className="fa fa-file-text-o fa-3x" />
                <br />
                {attachment.attachmentName.slice(-20)}
              </React.Fragment>
            )}
            <div className="attachment-thumbnail-btn-container">
              {this.canEdit && (
                <React.Fragment>
                  {this.hasThumbnail && (
                    <OverlayTrigger
                      placement="bottom"
                      overlay={toggleHideTooltip}
                    >
                      <button
                        className="btn note-attachment-delete-button btn-semi-transparent"
                        onClick={this.toggleAttachmentHidePreview}
                      >
                        <i className={previewIconClass} />
                      </button>
                    </OverlayTrigger>
                  )}
                  &nbsp;
                  <button
                    className="btn note-attachment-delete-button btn-semi-transparent"
                    onClick={this.handleAttachmentDelete}
                  >
                    <i className="fa fa-trash" />
                  </button>
                </React.Fragment>
              )}
            </div>
          </div>
        </div>
      </a>
    );

    // switch (attachmentExtension) {
    //     case 'jpg':
    //     case 'jpeg':
    //     case 'png':
    //     case 'gif':
    //         renderRetValue = (
    //             <a className="react-attachment-thumbnail-container" target="_blank" href={attachment.attachmentUrl}>
    //                 <div className="thumbnail">
    //                     <div className="attachment-thumbnail-img-holder">
    //                         <img src={attachment.attachmentUrl} alt="..."/>
    //                         <div className="attachment-thumbnail-btn-container">
    //                             {canEdit ?
    //                                 <button
    //                                     className='note-attachment-delete-button btn-transparent glyphicon glyphicon-trash'
    //                                     onClick={this.handleAttachmentDelete}/>
    //                                 : null}
    //                         </div>
    //                     </div>
    //                 </div>
    //             </a>
    //         );
    //         break;
    //     default:
    //         renderRetValue = (
    //             <a className="react-attachment-thumbnail-container" target="_blank" href={attachment.attachmentUrl}>
    //                 <div className="thumbnail">
    //                     <div className="attachment-thumbnail-img-holder">
    //                         <img src="" alt=""/>
    //                         <i className="fa fa-file-text-o fa-3x"/>
    //                         <br/>
    //                         {attachment.attachmentName.slice(-20)}
    //                         <div className="attachment-thumbnail-btn-container">
    //                             {canEdit ?
    //                                 <button
    //                                     className='note-attachment-delete-button btn-transparent glyphicon glyphicon-trash'
    //                                     onClick={this.handleAttachmentDelete}/>
    //                                 : null}
    //                         </div>
    //                     </div>
    //                 </div>
    //             </a>
    //         );
    //         break;
    // }
    //
    //
    // return renderRetValue;
  };

  handleAttachmentDelete = e => {
    e.preventDefault();
    e.stopPropagation();

    const { note, attachment } = this.props;

    note.deleteAttachment(attachment);
  };

  toggleAttachmentHidePreview = e => {
    e.preventDefault();
    e.stopPropagation();

    const { note, attachment } = this.props;

    note.toggleAttachmentHidePreview(attachment);
  };
}
